import { PlatformIcons } from '@clickcease/cc-client-components-lib'
import React, { ReactNode } from 'react'

type option = {
  id: number
  label: string
  icon: ReactNode
}

export const platformConnectionModalOptions: Array<option> = [
  { id: 1, label: 'Google', icon: <PlatformIcons serviceName="google" /> },
  { id: 2, label: 'Meta', icon: <PlatformIcons serviceName="meta" /> },
  { id: 3, label: 'Microsoft', icon: <PlatformIcons serviceName="microsoft" /> },
]

export const PlatformsLookupArr = ['google', 'meta', 'microsoft'] as const
